import React from 'react';
import ThirdPartyAccountManagementRouter from './ThirdPartyAccountManagementRouter';

export default function ThirdPartyAccountManagementPage() {
  return <ThirdPartyAccountManagementRouter />;
}
